module.exports = {
  siteTitle: 'Hulunlante Worku | Senior Backend Engineer | ELMIS',
  siteDescription:
    'Hulunlante Worku is a Senior Backend Engineer at ELMIS, building national-scale systems for Ethiopia\'s digital transformation.',
  siteKeywords:
    'Hulunlante Worku, Senior Backend Engineer, NestJS, Kafka, PostgreSQL, Microservices, ELMIS, Afriwork, Ethiopia, Backend Developer',
  siteUrl: 'https://hulunlante.netlify.app/',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-45666519-2',
  googleVerification: 'DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpbx9Lk',
  name: 'Hulunlante Worku',
  location: 'Addis Ababa, Ethiopia',
  email: 'hulunlante.w@gmail.com',
  github: 'https://github.com/HuluWZ',
  twitterHandle: '@HulunlanteWorku',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/HuluWZ',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/hulunlante-worku/',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/HulunlanteWorku',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/huluwz',
    },
  ],

  upworkUrl: 'https://www.upwork.com/freelancers/~01fe7b4c8026845f5f',

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
    {
      name: 'Hire Me 🚀',
      url: 'https://www.upwork.com/freelancers/~01fe7b4c8026845f5f',
    },

  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 100) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 100,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
